import { withBase } from 'ufo'

export function parseModifiers(modifiers) {
  return new URLSearchParams(modifiers)
}

export function getImage(src) {
  return {
    // eslint-disable-next-line no-undef
    url: withBase(src, useRuntimeConfig().public.autobidCMS.url),
  }
}
